// Sets document.title and the <meta name="description"> for the current route.
// Used by public pages that don't already manage their own meta (ServicePage,
// LocationPage, FreeEstimate manage their own).
import { useEffect } from "react";

export function useDocumentTitle(title, description) {
    useEffect(() => {
        if (title) document.title = title;
        if (description) {
            const meta =
                document.querySelector('meta[name="description"]') ||
                (() => {
                    const m = document.createElement("meta");
                    m.setAttribute("name", "description");
                    document.head.appendChild(m);
                    return m;
                })();
            meta.setAttribute("content", description);
        }
    }, [title, description]);
}
